import { lazy, type FC, type ReactElement, Suspense } from 'react'

import { Loader } from '../components/Loader'
import { useRequireAuth } from '../hooks/useRequireAuth'
import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'

const LazyPasskeyManagementPage = lazy(() =>
  import('../pages/PasskeyManagement/PasskeyManagementPage').then((module) => ({
    default: module.PasskeyManagementPage,
  })),
)

export const PasskeyManagementIOSRoute: FC = (): ReactElement => {
  const platform = 'ios'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  const { isAuthenticated } = useRequireAuth()

  if (!isAuthenticated) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyPasskeyManagementPage showBackButton={false} platform="ios" />
    </Suspense>
  )
}
